import passwordRecoveryDictionary from '@widgets/password-recovery-form/i18n/ru/password-recovery-form.dic.json';

export const passwordRecovery = {
  PASSWORD_RECOVERY: passwordRecoveryDictionary,
};

export const passwordRecoveryNamespaces = ['PASSWORD_RECOVERY'];
